import { Badge } from "@/components/ui/badge";
import CompressionExample from "@/components/CompressionExample";
import type { ToolExampleType } from "@/data/tools";

interface ToolExampleProps {
  toolExampleType: ToolExampleType;
  /** For conversion pages: e.g. "JPG" */
  sourceFormat?: string;
  /** For conversion pages: e.g. "WebP" */
  targetFormat?: string;
  /** For target-size pages: e.g. "200KB" */
  targetSize?: string;
}

const ToolExample = ({ toolExampleType, sourceFormat, targetFormat, targetSize }: ToolExampleProps) => {
  return (
    <div className="relative">
      {/* Contextual label above the example */}
      {toolExampleType === 'conversion' && sourceFormat && targetFormat && (
        <div className="flex justify-center mb-4">
          <Badge variant="outline" className="text-sm px-4 py-1.5 border-primary/30 text-primary">
            {sourceFormat} → {targetFormat}
          </Badge>
        </div>
      )}

      {toolExampleType === 'target-size' && targetSize && (
        <div className="flex justify-center mb-4">
          <Badge variant="outline" className="text-sm px-4 py-1.5 border-primary/30 text-primary">
            Objetivo: ≤ {targetSize}
          </Badge>
        </div>
      )}

      {toolExampleType === 'resize' && (
        <div className="flex justify-center mb-4">
          <Badge variant="outline" className="text-sm px-4 py-1.5 border-primary/30 text-primary">
            Redimensionar a medida
          </Badge>
        </div>
      )}

      {toolExampleType === 'crop' && (
        <div className="flex justify-center mb-4">
          <Badge variant="outline" className="text-sm px-4 py-1.5 border-primary/30 text-primary">
            Recortar imagen
          </Badge>
        </div>
      )}

      {toolExampleType === 'rotate' && (
        <div className="flex justify-center mb-4">
          <Badge variant="outline" className="text-sm px-4 py-1.5 border-primary/30 text-primary">
            Rotar / Voltear
          </Badge>
        </div>
      )}

      {toolExampleType === 'resize-percent' && (
        <div className="flex justify-center mb-4">
          <Badge variant="outline" className="text-sm px-4 py-1.5 border-primary/30 text-primary">
            Redimensionar por porcentaje
          </Badge>
        </div>
      )}

      {toolExampleType === 'batch' && (
        <div className="flex justify-center mb-4">
          <Badge variant="outline" className="text-sm px-4 py-1.5 border-primary/30 text-primary">
            Compresión en lote
          </Badge>
        </div>
      )}

      {toolExampleType === 'adjust' && (
        <div className="flex justify-center mb-4">
          <Badge variant="outline" className="text-sm px-4 py-1.5 border-primary/30 text-primary">
            Ajuste de imagen
          </Badge>
        </div>
      )}

      {toolExampleType === 'image-to-pdf' && (
        <div className="flex justify-center mb-4">
          <Badge variant="outline" className="text-sm px-4 py-1.5 border-primary/30 text-primary">
            Imagen a PDF
          </Badge>
        </div>
      )}

      <CompressionExample />
    </div>
  );
};

export default ToolExample;
